import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import {
  PromptDialogComponent
} from '../modules/shared/components/_dialog/prompt-dialog/prompt-dialog.component';
import {
  UnsavedChangesDialogComponent,
  UnsavedChangesDialogResult
} from '../modules/shared/components/_dialog/unsaved-changes-dialog/unsaved-changes-dialog.component';
import {
  CANCEL_PROMPT_DATA,
  CLOSE_ORDER_PROMPT_DATA,
  COPY_TASK_PROMPT_DATA,
  COPY_TASK_RESPONSE_PROMPT_DATA,
  FAILURE_OPTION_CHANGE_DATA,
  GO_ONLINE_PROMPT_DATA,
  IRREMOVABLE_FAILURE_DATA,
  SESSION_EXPIRATION_PROMPT_DATA,
  TASKS_MULTI_APPROVE_PROMPT_DATA
} from '../config/prompt.config';
import { PromptDataModel } from '../model/general.model';
import { TranslateService } from '@ngx-translate/core';
import {
  OrderCardDialogComponent
} from "../pages/orders-page/components/order-card-dialog/order-card-dialog.component";

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    private _dialog: MatDialog,
    private translate: TranslateService
  ) { }

  prompt(): MatDialogRef<PromptDialogComponent> {
    return this._dialog.open(PromptDialogComponent, {
      autoFocus: false
    });
  }

  promptForCopyTask(contentParam: string): MatDialogRef<PromptDialogComponent> {
    const dialogRef = this.prompt();
    dialogRef.componentInstance.promptData = {
      ...COPY_TASK_PROMPT_DATA,
      contentParam
    };

    return dialogRef;
  }
  promptForCopyTaskResult(content: string): MatDialogRef<PromptDialogComponent> {
    const dialogRef = this.prompt();
    dialogRef.componentInstance.isHtml = true;
    dialogRef.componentInstance.promptData = {
      ...COPY_TASK_RESPONSE_PROMPT_DATA,
      content
    };

    return dialogRef;
  }

  promptForCancelAction(): MatDialogRef<PromptDialogComponent> {
    const dialogRef = this.prompt();
    dialogRef.componentInstance.promptData = CANCEL_PROMPT_DATA;

    return dialogRef;
  }

  promptForSessionExpiration(): MatDialogRef<PromptDialogComponent> {
    const dialogRef = this.prompt();
    dialogRef.componentInstance.promptData = SESSION_EXPIRATION_PROMPT_DATA;

    return dialogRef;
  }

  promptForGoOnline(): MatDialogRef<PromptDialogComponent> {
    const dialogRef = this.prompt();
    dialogRef.componentInstance.promptData = GO_ONLINE_PROMPT_DATA;

    return dialogRef;
  }

  promptForCloseOrder(orderNumber: string): MatDialogRef<PromptDialogComponent> {
    const dialogRef = this.prompt();
    dialogRef.componentInstance.promptData = {
      ...CLOSE_ORDER_PROMPT_DATA,
      content: this.translate.instant(CLOSE_ORDER_PROMPT_DATA.content, { orderNumber })
    };

    return dialogRef;
  }

  showInfoDialog(data: PromptDataModel) {
    const dialogRef = this._dialog.open(PromptDialogComponent);
    dialogRef.componentInstance.promptData = data;
    return dialogRef;
  }

  promptForFailureOptionChange(): MatDialogRef<PromptDialogComponent> {
    const dialogRef = this.prompt();
    dialogRef.componentInstance.promptData = FAILURE_OPTION_CHANGE_DATA;
    return dialogRef;
  }

  promptForIrremovableFailure(): MatDialogRef<PromptDialogComponent> {
    const dialogRef = this.prompt();
    dialogRef.componentInstance.promptData = IRREMOVABLE_FAILURE_DATA;
    return dialogRef;
  }

  promptForUnsavedChanges(): MatDialogRef<UnsavedChangesDialogComponent, UnsavedChangesDialogResult> {
    return this._dialog.open(UnsavedChangesDialogComponent, { autoFocus: false });
  }

  showTasksMultiApprovePrompt(counter: number): MatDialogRef<PromptDialogComponent> {
    const dialogRef = this.prompt();
    dialogRef.componentInstance.promptData = {
      ...TASKS_MULTI_APPROVE_PROMPT_DATA,
      content: this.translate.instant(TASKS_MULTI_APPROVE_PROMPT_DATA.content, { counter })
    };
    return dialogRef;
  }

  showOrderCardDialog(): MatDialogRef<OrderCardDialogComponent> {
     return this._dialog.open(OrderCardDialogComponent, { autoFocus: false });
  }
}
